// @flow
import { InstanceSurveysActionTypes } from './constants';

const INIT_STATE = {
    instanceSurvey: {},
    listaInstanceSurveys: [],
    loading: false,
    error: false,
    formSubmited: false
};

type InstanceSurveysAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { instanceSurvey?: {} | null, listaInstanceSurveys?: [] | null, loading?: boolean, +value ?: boolean };

const InstanceSurveys = (state: State = INIT_STATE, action: InstanceSurveysAction): any => {
    // console.log(action);
    switch (action.type) {
        case InstanceSurveysActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case InstanceSurveysActionTypes.GET_INSTANCE_SURVEY: {
                    return {
                        ...state,
                        instanceSurvey: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS: {
                    return {
                        ...state,
                        listaInstanceSurveys: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY:
                case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR: {
                    return {
                        ...state,
                        instanceSurvey: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY:
                case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR:
                case InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstanceSurveysActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case InstanceSurveysActionTypes.GET_INSTANCE_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        instanceSurvey: {},
                        loading: false,
                    };
                }
                case InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaInstanceSurveys: [],
                        loading: false,
                    };
                }
                case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY:
                case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR: {
                    return {
                        ...state,
                        instanceSurvey: {},
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY:
                case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR:
                case InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case InstanceSurveysActionTypes.GET_INSTANCE_SURVEY:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.LIST_INSTANCE_SURVEYS:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.DELETE_INSTANCE_SURVEY:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.ADD_INSTANCE_SURVEY_QR:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.UPDATE_INSTANCE_SURVEY_QR:
            return { ...state, error: false, loading: true };
        case InstanceSurveysActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                instanceSurvey: {},
                listaInstanceSurveys: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default InstanceSurveys;
